// HallyuSuperstore API Integration
// Fetches all collections and products dynamically from the API

(function() {
  'use strict';
  
  window.HallyuSuperstoreAPI = {
    baseURL: 'https://hallyusuperstore19.myshopify.com',
    collections: [],
    currentProducts: [],
    
    // Initialize and fetch all collections
    async init() {
      console.log('Initializing HallyuSuperstore API...');
      await this.fetchAllCollections();
      this.setupEventListeners();
    },
    
    // Fetch all available collections from API
    async fetchAllCollections() {
      try {
        console.log('Fetching all collections from HallyuSuperstore...');
        
        const response = await axios.get(`${this.baseURL}/collections.json?limit=250`, {
          headers: {
            'X-Requested-With': undefined
          }
        });
        
        if (response.status === 200) {
          const data = response.data;
          this.collections = data.collections || [];
          
          // Sort collections by product count
          this.collections.sort((a, b) => {
            const countA = a.products_count || 0;
            const countB = b.products_count || 0;
            return countB - countA;
          });
          
          console.log(`Found ${this.collections.length} collections:`);
          this.collections.forEach(col => {
            console.log(`- ${col.handle}: ${col.title} (${col.products_count || 0} products)`);
          });
          
          // Dispatch event for theme editor
          window.dispatchEvent(new CustomEvent('hallyusuperstore:collections-loaded', {
            detail: { collections: this.collections }
          }));
          
          // Update collection selector if it exists
          this.updateCollectionSelector();
          
        } else {
          console.error('Failed to fetch collections:', response.status);
        }
      } catch (error) {
        console.error('Error fetching collections:', error);
      }
    },
    
    // Fetch products for a specific collection
    async fetchProducts(collectionHandle) {
      try {
        console.log(`Fetching products for collection: ${collectionHandle}`);
        
        let url;
        if (!collectionHandle || collectionHandle === 'all') {
          url = `${this.baseURL}/products.json?limit=250`;
        } else {
          url = `${this.baseURL}/collections/${collectionHandle}/products.json?limit=250`;
        }
        
        // Add headers to request USD prices
        const response = await axios.get(url, {
          headers: {
            'X-Shopify-Customer-Access-Token': '',
            'Accept': 'application/json',
            'X-Requested-With': undefined
          }
        });
        
        if (response.status === 200) {
          const data = response.data;
          this.currentProducts = data.products || [];
          
          console.log(`Found ${this.currentProducts.length} products in ${collectionHandle}`);
          
          // Display products
          this.displayProducts(this.currentProducts);
          
          return this.currentProducts;
        } else if (response.status === 404 && collectionHandle !== 'all') {
          console.log(`Collection ${collectionHandle} not found, trying alternative search...`);
          return await this.searchProductsByKeyword(collectionHandle);
        }
        
        return [];
      } catch (error) {
        console.error('Error fetching products:', error);
        return [];
      }
    },
    
    // Search products by keyword (fallback for collections not found)
    async searchProductsByKeyword(keyword) {
      try {
        const response = await axios.get(`${this.baseURL}/products.json?limit=250`, {
          headers: {
            'X-Requested-With': undefined
          }
        });
        
        if (response.status === 200) {
          const data = response.data;
          const searchTerm = keyword.toLowerCase().replace(/-/g, ' ');
          
          this.currentProducts = (data.products || []).filter(product => {
            const searchableText = `${product.title} ${product.vendor} ${product.tags} ${product.product_type}`.toLowerCase();
            return searchableText.includes(searchTerm);
          });
          
          console.log(`Found ${this.currentProducts.length} products matching "${keyword}"`);
          this.displayProducts(this.currentProducts);
          
          return this.currentProducts;
        }
        
        return [];
      } catch (error) {
        console.error('Error searching products:', error);
        return [];
      }
    },
    
    // Display products in the grid
    displayProducts(products) {
      const container = document.querySelector('[data-hallyusuperstore-products]');
      if (!container) return;
      
      container.innerHTML = '';
      
      if (products.length === 0) {
        container.innerHTML = '<div class="no-products">No products found in this collection</div>';
        return;
      }
      
      products.forEach(product => {
        const productCard = this.createProductCard(product);
        container.appendChild(productCard);
      });
    },
    
    // Create product card element
    createProductCard(product) {
      const card = document.createElement('div');
      card.className = 'hallyusuperstore-product-card';
      
      const image = product.images?.[0]?.src || product.image?.src || 'https://via.placeholder.com/300';
      
      // Get price and convert from KRW to USD
      let priceInUSD = '0.00';
      const variant = product.variants?.[0];
      
      if (variant && variant.price) {
        // Price from Shopify API is in KRW (Korean Won)
        const priceInKRW = parseFloat(variant.price);
        
        // Convert KRW to USD using approximate exchange rate
        // 1 USD ≈ 1,330 KRW (you may want to update this rate periodically)
        const exchangeRate = 1330;
        priceInUSD = (priceInKRW / exchangeRate).toFixed(2);
        
        console.log(`Product: ${product.title}, KRW: ${priceInKRW}, USD: ${priceInUSD}`);
      }
      
      const productUrl = `${this.baseURL}/products/${product.handle}`;
      
      card.innerHTML = `
        <a href="${productUrl}" target="_blank" rel="noopener noreferrer" class="product-link">
          <div class="product-image-wrapper">
            <img src="${image}" alt="${product.title}" loading="lazy">
            ${variant?.available === false ? '<div class="sold-out-badge">SOLD OUT</div>' : ''}
          </div>
          <div class="product-info">
            <h3 class="product-title">${product.title}</h3>
            <p class="product-vendor">${product.vendor || 'HallyuSuperstore'}</p>
            <p class="product-price">$${priceInUSD} USD</p>
          </div>
        </a>
      `;
      
      return card;
    },
    
    // Update collection selector dropdown
    updateCollectionSelector() {
      const selector = document.querySelector('[data-collection-selector]');
      if (!selector) return;
      
      // Clear existing options
      selector.innerHTML = '<option value="">Select a collection...</option>';
      selector.innerHTML += '<option value="all">All Products</option>';
      
      // Add all collections
      this.collections.forEach(collection => {
        if (collection.products_count > 0) {
          const option = document.createElement('option');
          option.value = collection.handle;
          option.textContent = `${collection.title} (${collection.products_count} products)`;
          selector.appendChild(option);
        }
      });
    },
    
    // Setup event listeners
    setupEventListeners() {
      // Listen for collection selector changes
      document.addEventListener('change', (e) => {
        if (e.target.matches('[data-collection-selector]')) {
          const handle = e.target.value;
          if (handle) {
            this.fetchProducts(handle);
          }
        }
      });
      
      // Listen for custom collection load events
      window.addEventListener('hallyusuperstore:load-collection', (e) => {
        const handle = e.detail.handle;
        this.fetchProducts(handle);
      });
    },
    
    // Get all available collection handles
    getCollectionHandles() {
      return this.collections.map(col => ({
        handle: col.handle,
        title: col.title,
        count: col.products_count || 0
      }));
    }
  };
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.HallyuSuperstoreAPI.init();
    });
  } else {
    window.HallyuSuperstoreAPI.init();
  }
})();